import { MouseEvent, useEffect, useState } from 'react';
import * as S from './styles';
import { getSlotLength } from './utils';

interface Props {
  personId: string;
  taughtAt: string;
  endedAt: string;
  personName: string;
  round: number;
  totalRound: number;
  onClick?: (e: MouseEvent) => void;
  isGroup?: boolean;
}

export default function LectureScheduleSlot({
  personId,
  taughtAt,
  endedAt,
  personName,
  round,
  totalRound,
  onClick,
  isGroup
}: Props) {
  const [length, setLength] = useState<number>();

  useEffect(() => {
    setLength(getSlotLength(taughtAt, endedAt));
  }, []);

  if (!length) {
    return null;
  }

  return (
    <S.Container onClick={onClick}>
      <S.Contents personId={personId ?? ''} length={length}>
        {isGroup ? (
          <S.UserName>그룹 수업</S.UserName>
        ) : (
          <>
            <S.UserName>
              {personName.length > 3 ? personName.slice(0, 3) : personName}
            </S.UserName>
            <S.Round>
              {round} / {totalRound}
            </S.Round>
          </>
        )}
      </S.Contents>
    </S.Container>
  );
}
